import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", [_c("wlc-breadcrumb"), _c("div", {
    staticClass: "wlc-space-between"
  }, [_c("el-form", {
    attrs: {
      inline: true,
      model: _vm.searchForm,
      size: "small"
    },
    nativeOn: {
      submit: function submit($event) {
        $event.preventDefault();
      }
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "手机号"
    }
  }, [_c("el-input", {
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.getData("search");
      }
    },
    model: {
      value: _vm.searchForm.phone,
      callback: function callback($$v) {
        _vm.$set(_vm.searchForm, "phone", $$v);
      },
      expression: "searchForm.phone"
    }
  })], 1), _c("el-form-item", [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.getData("search");
      }
    }
  }, [_vm._v("搜索 ")])], 1)], 1), _c("el-form", {
    attrs: {
      inline: true,
      size: "small",
      model: _vm.searchForm
    }
  }, [_c("el-form-item", [_c("el-button", {
    attrs: {
      type: "danger"
    },
    on: {
      click: function click($event) {
        _vm.form = {};
        _vm.dialogVisible = true;
      }
    }
  }, [_vm._v("注销 ")])], 1)], 1)], 1), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.tableLoading,
      expression: "tableLoading"
    }],
    attrs: {
      data: _vm.tableData,
      border: ""
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "name",
      label: "姓名",
      width: "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var userInfo = _ref.row.userInfo;
        return [_c("wlc-user-pop", {
          attrs: {
            info: userInfo
          },
          on: {
            saveRemark: _vm.saveRemark
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "phone",
      label: "手机",
      width: "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(scope.row.phone.replace("2188", "")) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "cancelTime",
      label: "注销时间",
      width: "120"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "cancelMethod",
      label: "注销方式",
      width: "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref2) {
        var cancelMethod = _ref2.row.cancelMethod;
        return [_vm._v(" " + _vm._s(cancelMethod) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "remark",
      label: "备注",
      width: "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("wlc-remark-list", {
          attrs: {
            remarkList: scope.row.remarkList,
            remark: scope.row.remark
          }
        })];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "gender",
      width: "100",
      label: "性别"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.gender == 1 ? _c("span", [_vm._v("男")]) : scope.row.gender == 2 ? _c("span", [_vm._v("女")]) : _c("span", [_vm._v("男")])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "age",
      width: "100",
      label: "年龄"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "occupation",
      width: "100",
      label: "职业"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "from",
      label: "来自",
      "min-width": "100"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "isRelease",
      label: "用户类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.houseReleaseState == 1 ? _c("el-tag", {
          attrs: {
            size: "mini",
            type: "danger"
          }
        }, [_vm._v("房东ING ")]) : _c("div", [scope.row.isRelease == 1 ? _c("el-tag", {
          attrs: {
            size: "mini",
            type: "primary"
          }
        }, [_vm._v("房客 ")]) : _vm._e(), scope.row.isRelease == 2 ? _c("el-tag", {
          attrs: {
            size: "mini",
            type: "success"
          }
        }, [_vm._v("房东 ")]) : _vm._e()], 1)];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "mail",
      label: "邮箱"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "cancelTime",
      label: "注销时间",
      width: "150"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "版本信息",
      width: "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("wlc-app-version", {
          attrs: {
            info: scope.row.appInfo
          }
        })];
      }
    }])
  })], 1), _c("div", {
    staticClass: "wlc-pagination"
  }, [_c("el-pagination", {
    attrs: {
      layout: "total, prev, pager, next",
      "page-size": _vm.searchForm.ps,
      "current-page": _vm.searchForm.pn,
      total: _vm.total
    },
    on: {
      "current-change": _vm.pageChange
    }
  })], 1), _c("el-dialog", {
    attrs: {
      title: "注销账号",
      visible: _vm.dialogVisible,
      width: "400px"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.dialogVisible = $event;
      }
    }
  }, [_c("el-form", {
    attrs: {
      "label-width": "60px",
      model: _vm.form
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "手机号"
    }
  }, [_c("el-input", {
    model: {
      value: _vm.form.phone,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "phone", $$v);
      },
      expression: "form.phone"
    }
  })], 1)], 1), _c("div", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    attrs: {
      type: "primary",
      loading: _vm.loadingDialog
    },
    on: {
      click: function click($event) {
        return _vm.logoutUser();
      }
    }
  }, [_vm._v("确 定 ")])], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };